"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// const {NotAllSelectedIcon} = require('@tencent/ixd-icons-react/dist')
var Svg = function Svg() {
  return (
    /*#__PURE__*/
    // const { dataIndex, checked } = props;
    // if( dataIndex===0 && !checked ){
    //   return <NotAllSelectedIcon className='svg'/>
    // } else {
    //   return <svg className='svg' width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <path fill-rule="evenodd" clip-rule="evenodd" d="M0.810418 4.0393L0 4.88935L3.8443 9L12 0.880689L11.1476 0L3.78876 6.37899L0.810418 4.0393Z" fill="#006EFF" />
    // </svg>
    // }
    // <NotAllSelectedIcon className='svg'/>
    React.createElement("svg", {
      className: "svg",
      width: "12",
      height: "9",
      viewBox: "0 0 12 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.810418 4.0393L0 4.88935L3.8443 9L12 0.880689L11.1476 0L3.78876 6.37899L0.810418 4.0393Z",
      fill: "#006EFF"
    }))
  );
};

var _default = Svg;
exports["default"] = _default;